module.exports = __webpack_public_path__ + "static/media/2_pl.ebb7e533.png";